/* eslint-disable import/no-cycle */
import api from './api.service';

function getInfo(type, params) {
  return api.get(`/importer-info/${type}`, params);
}

export const importerInfoService = {
  getInfo,
};
